import { Component } from '@angular/core';
import { UserManagementService } from "./user-management.service";
import { User } from "./user";
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { trigger, style, animate, transition } from '@angular/animations';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { SearchTableState } from "../search-table-state";
import { Column } from "../column";
import { AlertService } from "../../../services";
import { PageStateService } from "../page-state.service";
import { BaseTableComponent } from "../base-table.component";
import { PermissionService } from "../../../services/SecurityServices/permission.service";
import * as FileSaver from "file-saver";

@Component({
    template: require('./user-management-table.html'),
    providers: [UserManagementService, LocalStorageService],
    styles: [require('../table.css')]
})

export class UserManagementTableComponent extends BaseTableComponent {

    private users = new Array<User>();
    private userStatus = new Array<User>();
    private searchTableState: SearchTableState;
    private columns: Array<Column>;
    private busy: Subscription;
    private queryParamsSub: any;
    private showFilter: boolean = false;
    private static lastRefreshed: string = 'user-last-refreshed';
    private disableUsers: boolean = false;
    private disableExportToExcel: boolean = false;
    private disableViewUser: boolean = false;
    private disablePostUser: boolean = false;
    private dateFormat: string = 'yyyy-mm-dd';
    private datePickerOptions: IMyDpOptions = {
        height: '30px',
        dateFormat: this.dateFormat
    };

    constructor(
        private userManagementService: UserManagementService,
        private router: Router,
        private route: ActivatedRoute,
        private alertService: AlertService,
        private pageStateService: PageStateService,
        private localStorageService: LocalStorageService,
        private permissionService: PermissionService
    ) {
        super(localStorageService, userManagementService.searchTableState);
        this.setColumns();
    }

    public goTo(value: number): void {
        if (value <= this.searchTableState.pageCount()) {
            this.searchTableState.pageChange(value);
            this.updateTable();
        }
    }

    ngOnInit() {
        this.setPermissions();
        this.searchTableState = this.userManagementService.searchTableState;
        this.searchTableState.currentPage = this.pageStateService.currentUserPage;
        this.setPageSize('user-page-size');
        this.blankPage();
        this.setLastRefreshed(UserManagementTableComponent.lastRefreshed);
        let self: UserManagementTableComponent = this;
        this.queryParamsSub = this.route.paramMap.subscribe((params: ParamMap) => {
            self.searchTableState.permissionsValue = -1;
            self.updateTable();
        });
    }

    ngOnDestroy() {
        this.pageStateService.currentUserPage = this.searchTableState.currentPage;
        this.queryParamsSub.unsubscribe();
    }

    private setPermissions(): void {
        let hasPermission: boolean = this.permissionService.userHasPermission('Users_SetBulkUserStatus');
        if (hasPermission) {
            this.disableUsers = !hasPermission;
            return;
        } else {
            this.disableUsers = !this.permissionService.userHasPermission('Users_SetUserStatus');
        }
        this.disableViewUser = !this.permissionService.userHasPermission('View_User');
        this.disablePostUser = !this.permissionService.userHasPermission('Users_PostUser');
        this.disableExportToExcel = !this.permissionService.userHasPermission('Users_ExportExcel');
    }

    private setColumns() {
        this.columns = new Array<Column>();     
        this.columns.push(new Column('Mobile Number', 'MobileNumber'));
        this.columns.push(new Column('Email', 'Email'));
        this.columns.push(new Column('First Name', 'FirstName'));
        this.columns.push(new Column('Surname', 'Surname'));
        this.columns.push(new Column('Date Created', 'CreatedDateUtc'));
        this.columns.push(new Column('', ''));
        this.columns.push(new Column('Status', 'StatusId'));
    }

    private blankPage() {
        this.users = new Array<User>();
        for (let i: number = 0; i < this.searchTableState.itemsPerPage; i++) {
            this.users.push(new User());
        }
    }
 
    private exportExcel(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: UserManagementTableComponent = this;
        this.userManagementService.exportExcel().subscribe(blob => {
            self.searchTableState.updating = false;
            if (!blob) {
                return;
            }
            var fileName = 'Users_' + this.searchTableState.lastRefreshed + '.xlsx';
            FileSaver.saveAs(blob, fileName);
            self.alertService.success('File generated successfully.');
        }, error =>  self.searchTableState.updating = false);
    }

    private filterTable(): void{
        if (this.searchTableState.fromDate && this.searchTableState.toDate && this.searchTableState.fromDate.getTime() > this.searchTableState.toDate.getTime()) {
            this.alertService.error('From Date cannot be more than To Date');
            return;
        }
        this.updateTable();
    }

    private updateTable(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: UserManagementTableComponent = this;
        this.busy = this.userManagementService.search().subscribe((message: Array<User>) => {
            self.searchTableState.updating = false;
            self.users = message;
        }, error => self.searchTableState.updating = false);
    }

    private onClick(user: User): void {
        if (!this.disableViewUser) {
            this.router.navigate(['admin/user-management/user', user ? user.userId : 'new']);
        }
    }

    private refreshTable() {
        if (this.searchTableState.updating) {
            return;
        }
        this.updateLastRefreshed(UserManagementTableComponent.lastRefreshed);
        this.updateTable();
    }

    private disableUser(e: boolean, user: User) {
        user.statusId = e;
        let self: UserManagementTableComponent = this;
        this.busy = this.userManagementService.setBulkUserStatus([user.userId], !user.statusId).subscribe(() => {
        }, error => user.statusId = false);
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/user/user-management-table.component.ts